import EventsHelper from "../../_helpers/events";
import { localLangVal } from "../../_helpers";

export const openCalendar = (selector, openDate, _ref) => {
  const $selector = $(selector);
  if (!!$selector && !$selector.hasClass("show")) {
    $selector.datepicker({
      firstDay: 1,
      dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
      monthNames: window.gsConfig?.translations?.monthsFull,
      monthNamesShort: window.gsConfig?.translations?.months,
      beforeShowDay(date) {
        const dateStr = getDateString(date);
        const yearlyMatchDaysData = _ref.yearlyMatchDaysData;
        if (
          !!yearlyMatchDaysData &&
          !yearlyMatchDaysData.matchDays?.includes(dateStr)
        ) {
          return [true, "vbw-has-no-matches"];
        }
        
        return [true, ""];
      },
      onChangeMonthYear(year, month, widget) {
        const yearlyMatchDaysData = _ref.yearlyMatchDaysData;
        const calendarYear = _ref.calendarYear;
        if (!!yearlyMatchDaysData && year !== calendarYear) {
          getMatchDaysData(
            year,
            yearlyMatchDaysData.timeOffset,
            function (matchDaysData, _ref) {
              _ref.yearlyMatchDaysData = matchDaysData;
            },
            _ref,
          );
        }
      },
      onSelect(dateText, inst) {
        const day = inst.selectedDay;
        const month = inst.selectedMonth;
        const year = inst.selectedYear;
        const fromDate = new Date(year, month, day);
        const toDate = new Date(year, month, day);
        toDate.setDate(toDate.getDate() + 6);
        EventsHelper.GlobalScheduleWeeklyNavChange(fromDate, toDate);
      },
    });
    $selector.addClass("show");

    if (openDate) {
      $($selector).datepicker({ dateFormat: "yyyy-mm-dd" }); // format to show
      $($selector).datepicker("setDate", openDate);
    }

    //bug in calendar
    $selector.find(".ui-state-active").removeClass("ui-state-hover");
    markDatesInCalendar(_ref);
    addCalendarListeners();
  } else {
    closeCalendar(selector, _ref);
  }
};

export const addCalendarListeners = () => {
  $(document).on("mouseover", '[data-handler="selectDay"]', function () {
    const currentDay = parseInt($(this).text());
    for (let i = 1; i <= 6; i++) {
      const date = currentDay + i;
      $("[data-date='" + date + "']").addClass("ui-state-hover");
    }
  });
  $(document).on("mouseout", '[data-handler="selectDay"]', function () {
    const calendarDays = $(".ui-state-default");
    for (const day of calendarDays) {
      $(day).removeClass("ui-state-hover");
    }
  });
  $(".calendar-button-today").on("click", function () {
    const fromDate = new Date();
    const toDate = new Date();
    toDate.setDate(fromDate.getDate() + 6);
    EventsHelper.GlobalScheduleWeeklyNavChange(fromDate, toDate);
  });
};

export const closeCalendar = (selector, _ref) => {
  const $selector = $(selector);
  if (!$selector) return;
  _ref.calendarYear = new Date().getFullYear();
  $selector.datepicker("destroy");
  $selector.removeClass("show");
};

export const markDatesInCalendar = (_ref) => {
  const calendarDays = $(".ui-datepicker-calendar")?.find("tr")?.find("td");
  const yearlyMatchDaysData = _ref.yearlyMatchDaysData;

  if (!calendarDays || !yearlyMatchDaysData) return;
  for (const calendarDay of calendarDays) {
    const $calendarDay = $(calendarDay);
    if (!$calendarDay.hasClass("ui-datepicker-other-month")) {
      const year = $calendarDay.attr("data-year");
      let month = $calendarDay.attr("data-month");
      let day = $calendarDay.find("a").attr("data-date");
      month = parseInt(month) + 1;
      if (month.toString().length === 1) month = `0${month}`;
      if (day.length === 1) day = `0${day}`;
      const fullDay = `${year}-${month}-${day}`;
      if (!yearlyMatchDaysData.matchDays?.includes(fullDay)) {
        $calendarDay.addClass("vbw-has-no-matches");
      } else {
        $calendarDay.removeClass("vbw-has-no-matches");
      }
    }
  }
};

export const getDateString = (date, isMatchTBD = false) => {
  let da = new Date(date);
  if (isMatchTBD) {
    da.setMinutes(da.getMinutes() + da.getTimezoneOffset());
  }
  const monthNumb = da.getMonth() + 1;
  const dateNumb = da.getDate();

  const dateVal = dateNumb < 10 ? "0" + dateNumb : dateNumb;
  const monthVal = monthNumb < 10 ? "0" + monthNumb : monthNumb;
  return da.getFullYear() + "-" + monthVal + "-" + dateVal;
};

export const getMatchDaysData = (year, utcOffset, callBack, _ref) => {
  _ref.calendarYear = year;
  _ref.yearlyMatchDaysData = null;
  $.ajax({
    headers: {
      "Content-Type": "application/json",
    },
    cache: true,
    type: "GET",
    url: window.gsConfig.calendarApi
      .replace("{year}", year)
      .replace("{utcOffset}", utcOffset)
      .replace("{volleyTournamentIDs}", window.gsConfig.volleyTournamentIDs)
      .replace("{beachTournamentIDs}", window.gsConfig.beachTournamentIDs),
  })
    .done(function (data) {
      if (callBack && _ref) {
        callBack(data, _ref);
        markDatesInCalendar(_ref);
      }
    })
    .fail(function (err) {
      console.log("Match Days Calendar Api err: ", err);
    });
};

export const getMatchCards = (matches, model, templates, isLocalTime, rankingData) => {
  // sort matched by date
  matches = matches?.sort(function (a, b) {
    return new Date(a.matchDateUtc) - new Date(b.matchDateUtc);
  });

  // group matches by Dates
  const matchesGroupByDate = getMatchesGroupByDate(matches, isLocalTime);
  if (!matchesGroupByDate) return [];

  const datesArr = [];
  const listedComps = [];
  const listedDisciplines = [];
  const listedGenders = [];
  const listedTeams = [];
  const listedPools = [];
  const listedRounds = [];
  const listedVenues = [];

  for (const dateKey of Object.keys(matchesGroupByDate)) {
    // group by Competition for each date
    const matchesGroupByComp = getMatchesGroupByComp(matchesGroupByDate[dateKey]);
    const competitionArr = [];

    for (const compKey of Object.keys(matchesGroupByComp)) {
      const competitionData = model.allTournaments?.filter(
        (x) => x.competitionSlug === compKey,
      );

      if (competitionData?.length === 0) return [];

      updateCompFilterList(competitionData[0], listedComps, listedDisciplines);

      const matchArr = [];
      const compKeyMatches = matchesGroupByComp[compKey];
      const sortedTBDMatches = getMatchTBDSorted(compKeyMatches);

      for (const r in sortedTBDMatches) {
        const matchData = compKeyMatches[r];
        const [matchItem, homeTeam, awayTeam] = updateMatchCard(
          templates,
          matchData,
          model,
          competitionData[0],
          isLocalTime,
          rankingData
        );
        matchArr.push(matchItem.html());

        // Update Listed Gender, Pool and Round data for filter
        updateFilterArrListOne(matchData, listedGenders, listedPools, listedRounds);
        updateFilterArrListTwo(matchData, listedVenues, listedTeams, homeTeam, awayTeam);
      }

      // Send matches markup to competition row
      const compItem = updateCompetitionRow(
        templates.comp,
        competitionData[0],
        matchArr,
      );
      competitionArr.push(compItem.html());
    }

    // Send Competition markup to dates row
    const dateItem = updateDateRow(templates.date, dateKey, competitionArr);
    datesArr.push(dateItem.html());
  }

  return [
    datesArr,
    {
      listedComps,
      listedGenders,
      listedDisciplines,
      listedTeams,
      listedPools,
      listedRounds,
      listedVenues,
    },
  ];
};

const getMatchesGroupByDate = (matches, isLocalTime) => {
  return matches?.reduce((acc, cur) => {
    const timeVal = isLocalTime ? getDateString(cur.matchDateTimeLocal) : getDateString(cur.matchDateUtc);
    const date = cur.isMatchTBD ? getDateString(cur.matchDateUtc, true) : timeVal;
    return ((acc[date] || (acc[date] = [])).push(cur), acc);
  }, {});
}

const getMatchesGroupByComp = (dateKeyComps) => {
  return dateKeyComps?.reduce((acc, cur) => {
    const compSlug = cur?.competitionSlug;
    return ((acc[compSlug] || (acc[compSlug] = [])).push(cur), acc);
  }, {});
}

const getMatchTBDSorted = (compKeyMatches) => {
  return compKeyMatches.sort(
    function (firstmatch, secondmatch) {
      const isFirstMatchTBD = firstmatch?.isMatchTBD ? 1 : -1;
      return firstmatch?.isMatchTBD === secondmatch?.isMatchTBD ? 0 : isFirstMatchTBD;
    },
  )
}

const updateCompFilterList = (competitionData, listedComps, listedDisciplines) => {
  if (!containsCompetition(competitionData, listedComps)) {
    listedComps.push(competitionData);
  }

  if (!containsDiscipline(competitionData, listedDisciplines)) {
    listedDisciplines.push(competitionData);
  }
}

const updateFilterArrListOne = (matchData, listedGenders, listedPools, listedRounds) => {
  // update gender filter data
  if (!!matchData.gender && listedGenders?.indexOf(matchData.gender) === -1
  ) {
    listedGenders.push(matchData.gender);
  }

  if (matchData.discipline === "volley") {
    // Pools data for filter
    if (
      !!matchData.pool?.name &&
      listedPools?.findIndex(
        (pool) => pool.poolName == matchData.pool?.name,
      ) === -1
    ) {
      listedPools.push({
        poolName: matchData.pool.name,
        matchDate: matchData.matchDateUtc,
      });
    }
    // Rounds data for filter
    if (
      !!matchData.roundName &&
      listedRounds?.indexOf(matchData.roundName) === -1
    ) {
      listedRounds.push(matchData.roundName);
    }
  } else if (matchData.discipline === "beach") {
    // Pools data for filter
    if (
      !!matchData.roundName &&
      listedPools?.findIndex(
        (pool) => pool.poolName == matchData.roundName,
      ) === -1
    ) {
      listedPools.push({
        poolName: matchData.roundName,
        matchDate: matchData.matchDateUtc,
      });
    }
  }
}

const updateFilterArrListTwo = (matchData, listedVenues, listedTeams, homeTeam, awayTeam) => {
  // Venue data for filter
  if (
    !!matchData.city &&
    listedVenues?.indexOf(matchData.city) === -1
  ) {
    listedVenues.push(matchData.city);
  }

  // Teams data for filter
  if (
    !!homeTeam?.translatedName &&
    listedTeams?.indexOf(homeTeam?.translatedName) === -1
  ) {
    listedTeams.push(homeTeam?.translatedName);
  }
  if (
    !!awayTeam?.translatedName &&
    listedTeams?.indexOf(awayTeam?.translatedName) === -1
  ) {
    listedTeams.push(awayTeam?.translatedName);
  }
}

export const getCompetitionCards = (competitions, templates) => {
  const listedGenders = [];
  const listedDisciplines = [];
  const listedCompeTypes = [];

  // group matches by Status
  const compsGroupedByStatus = getCompsGroupedByStatus(competitions);
  const statusArr = [];

  if (!compsGroupedByStatus) return [];

  for (const statusKey of Object.keys(compsGroupedByStatus)) {
    let statusKeyComps = compsGroupedByStatus[statusKey];
    const competitionsArr = [];

    statusKeyComps.sort(function (a, b) {
      return new Date(a.startDate) - new Date(b.startDate);
    });

    statusKeyComps.forEach((compData) => {
      const genders = getCompetitionGender(compData);
      let matchItem = updateCompetitionCard(templates, compData, genders);
      competitionsArr.push(matchItem.html());
      updateCompFiltersArr(genders, compData, listedGenders, listedCompeTypes, listedDisciplines);
    });

    const statusItem = updateYearlyStatusCard(
      templates,
      statusKey,
      competitionsArr,
    );
    statusArr.push(statusItem.html());
  }

  return [statusArr, {
    listedGenders,
    listedDisciplines,
    listedCompeTypes
  }];
};

const getCompsGroupedByStatus = (competitions) => {
  return competitions?.reduce((acc, cur) => {
    return ((acc[cur.status] || (acc[cur.status] = [])).push(cur), acc);
  }, {});
}

const updateCompFiltersArr = (genders, compData, listedGenders, listedCompeTypes, listedDisciplines) => {
  //get gender filters
  if (!!genders && genders.length > 0) {
    genders.forEach((gender) => {
      if (listedGenders?.indexOf(gender) === -1)
        listedGenders.push(gender);
    });
  }

  // Get Compe Types for filter
  if (!!compData.subCompetitionType && listedCompeTypes?.indexOf(compData.subCompetitionType) === -1) {
    listedCompeTypes.push(compData.subCompetitionType);
  }

  if (!!compData && listedDisciplines?.indexOf(compData.discipline) === -1) {
    listedDisciplines.push(compData.discipline);
  }
}

export const getCompetitionGender = (compData) => {
  const genders = [];
  if (compData.menTournaments) {
    genders.push("Men");
  }
  if (compData.womenTournaments) {
    genders.push("Women");
  }
  return genders;
}

export const convertToSlug = (text) => {
  return text ? text.toLowerCase().replace(/ /g, "-") : "";
};

export const updateYearlyStatusCard = (templates, statusKey, competitionsArr) => {
  if (!competitionsArr)
    return;
  const status = getCompetitionStatus(statusKey);
  templates.yearlyStatus.find(".vbw-gs2-status-text").text(status);
  templates.yearlyStatus.find(".vbw-gs2-status-body").html(competitionsArr);
  return templates.yearlyStatus;
}

export const getCompetitionStatus = (statusKey) => {
  if (statusKey == 0) {
    return window.gsConfig?.translations?.ongoing;
  }
  else if (statusKey == 2) {
    return window.gsConfig?.translations?.completed;
  }
  else {
    return window.gsConfig?.translations?.upcoming;
  }
}

export const updateCompetitionRow = (selector, data, matchesContent) => {
  const compName = getCompetitionName(data);

  selector.find(".vbw-gs2-comp-row").attr("data-tournament", data?.no);
  selector
    .find(".vbw-gs2-comp-row")
    .attr("data-tournament-name", convertToSlug(compName));
  selector
    .find(".vbw-gs2-comp-img-wrap img")
    .attr("data-comp-square-logo", data?.no);
  selector.find(".vbw-gs2-comp-img-wrap img").attr("alt", data?.name);
  selector.find(".vbw-gs2-comp-title").text(compName);

  // Update competition page url
  if (!data?.url || data?.url === "#nolink") {
    selector.find(".vbw-comp-page-link").each(function () {
      $(this).addClass("disabled");
      $(this).attr("href", "#nolink");
      $(this).attr("alt", "");
    });
  } else {
    selector.find(".vbw-comp-page-link").each(function () {
      $(this).removeClass("disabled");
      $(this).attr("href", data.url);
      $(this).attr("alt", compName);
    });
  }

  selector.find(".vbw-gs2-comp-body").html(matchesContent.join(""));
  return selector;
};

export const updateDateRow = (selector, date, compContent) => {
  const weekDate = new Date(date);
  weekDate.setMinutes(weekDate.getMinutes() + weekDate.getTimezoneOffset());
  const displayDate =
    weekDate.toLocaleString(localLangVal(), { day: "numeric" }) +
    " " +
    weekDate.toLocaleString(localLangVal(), { month: "long" });
  selector.find(".vbw-gs2-date-text").text(displayDate);
  selector.find(".vbw-gs2-date-row").attr("data-date", weekDate);

  selector.find(".vbw-gs2-date-body").html(compContent.join(""));
  return selector;
};

export const getCompetitionName = (competition) => {
  const compFullName = competition?.competitionFullName ? competition?.competitionFullName : competition?.name;
  return competition?.competitionShortName ? competition?.competitionShortName : compFullName;
};

export const updateMatchCard = (templates, data, model, tournament, isLocalTime, rankingData) => {
  const [matchHours, matchMins] = getMatchHourMins(data, isLocalTime);
  const [homeTeam, homeContent] = getTeamContent(
    templates,
    data,
    model.allTeams,
    "home",
  );
  const [awayTeam, awayContent] = getTeamContent(
    templates,
    data,
    model.allTeams,
    "away",
  );

  // update match card wrapper
  updateMatchCardClass(
    "vbw-gs2-match-item",
    templates.match.find("[js-match-item]"),
    data?.matchStatus,
  );
  templates.match.find("[js-match-item]").attr("data-match-id", data?.matchNo);
  templates.match
    .find("[js-match-item]")
    .attr("data-competition-id", data?.tournamentNo);
  templates.match
    .find("[js-match-item]")
    .attr("data-competition-name", data?.competitionSlug);
  templates.match
    .find("[js-match-item]")
    .attr("data-gender", convertToSlug(data?.gender));

  updatePoolRoundValues(data, templates);

  templates.match
    .find("[js-match-item]")
    .attr("data-venue", convertToSlug(data?.city));
  templates.match
    .find("[js-match-item]")
    .attr("data-utc-time", data?.matchDateUtc);
  templates.match
    .find("[js-match-item]")
    .attr("data-local-time", data?.matchDateTimeLocal);
  templates.match
    .find("[js-match-item]")
    .attr(
      "data-country",
      convertToSlug(homeTeam?.translatedName + "/" + awayTeam?.translatedName),
    );
  templates.match
    .find("[js-match-item]")
    .attr("data-discipline", data?.discipline);
  templates.match.find(".vbw-gs2-match-venue-country").text(data?.country);

  if (data?.city) {
    templates.match.find(".vbw-gs2-match-venue-city").show();
    templates.match.find(".vbw-gs2-match-venue-city").text(data?.city);
  } else {
    templates.match.find(".vbw-gs2-match-venue-city").hide();
  }

  // update teams content
  templates.match
    .find(".vbw-gs2-match-team.--home")
    .html(homeContent)
    .append('<span class="vbw-teams-separator"></span>');
  templates.match.find(".vbw-gs2-match-team.--away").html(awayContent);

  // Add teams names to html for filter
  templates.match
    .find("[js-match-item]")
    .attr(
      "data-teamname",
      homeTeam?.translatedName +
      "/" +
      awayTeam?.translatedName +
      "/" +
      data?.city +
      "/" +
      data?.competitionShortName +
      "/" +
      data?.competitionFullName,
    );

  // update sets content
  updateSetsContent(data, templates);

  // Time and timezone
  if (!data?.isMatchTBD)
    templates.match
      .find(".vbw-gs2-start-time")
      .text(matchHours + ":" + matchMins);
  else templates.match.find(".vbw-gs2-start-time").text("TBD");

  // Update Match Center Link
  updateMatchCenterLink(data, templates);

  // Match round and pool details
  updateMatchRoundPool(data, templates);

  templates.match.find(".vbw-gs2-match-gender").text(data?.gender);
  templates.match.find(".vbw-gs2-match-gender").removeClass("--dark");
  if (data.gender.toLowerCase() === "men") {
    templates.match.find(".vbw-gs2-match-gender").addClass("--dark");
  }

  // Match links
  updateMatchLinks(data, tournament, templates);

  // Update match rankings section
  templates.match.find(".vbw-gs2-rankings-wrap").html(updateMatchRanking(templates, data, rankingData, homeContent, awayContent));

  return [templates.match, homeTeam, awayTeam];
};

export const getMatchHourMins = (data, isLocalTime) => {
  const matchDate = new Date(isLocalTime ? data.matchDateTimeLocal : data.matchDateUtc);
  const matchHours = matchDate?.getHours().toString().length < 2
    ? "0" + matchDate?.getHours().toString()
    : matchDate?.getHours().toString();
  const matchMins = matchDate?.getMinutes().toString().length < 2
    ? "0" + matchDate?.getMinutes().toString()
    : matchDate?.getMinutes().toString();

  return [matchHours, matchMins]
}

const updatePoolRoundValues = (data, templates) => {
  if (data.discipline === "volley") {
    templates.match.find("[js-match-item]").attr("data-pool", convertToSlug(data.pool?.name));
    templates.match.find("[js-match-item]").attr("data-round", convertToSlug(data.roundName));
  } else if (data.discipline === "beach") {
    templates.match.find("[js-match-item]").attr("data-pool", convertToSlug(data.roundName));
    templates.match.find("[js-match-item]").attr("data-round", convertToSlug(""));
  }
}

const updateMatchLinks = (data, tournament, templates) => {
  if (data.teamBNo !== -1 && data.teamANo !== -1) {
    if (!!data.ticketLink && data.matchStatus !== 2 && data.matchStatus !== 1) {
      templates.match
        .find(".vbw-gs2-match-links .--ticket")
        .attr("href", data?.ticketLink);
      templates.match
        .find(".vbw-gs2-match-links .--ticket")
        .attr("title", data?.competitionFullName + " tickets");
      templates.match.find(".vbw-gs2-match-links .--ticket").show();
    } else {
      templates.match.find(".vbw-gs2-match-links .--ticket").hide();
    }

    if (tournament?.storeLink) {
      templates.match
        .find(".vbw-gs2-match-links .--shop")
        .attr("href", tournament?.storeLink);
      templates.match
        .find(".vbw-gs2-match-links .--shop")
        .attr("title", data.competitionFullName + " shop link");
      templates.match.find(".vbw-gs2-match-links .--shop").show();
    } else {
      templates.match.find(".vbw-gs2-match-links .--shop").hide();
    }

    if (data.volleyBallTvLink) {
      templates.match
        .find(".vbw-gs2-match-links .--vbtv-link")
        .attr("href", data.volleyBallTvLink);
      templates.match
        .find(".vbw-gs2-match-links .--vbtv-link")
        .attr("title", data.competitionFullName + " vbtv link");
      templates.match.find(".vbw-gs2-match-links .--vbtv-link").show();
      templates.match.find(".vbw-gs2-match-links .--youtube-link").hide();
    } else if (data.youTubeLink) {
      templates.match
        .find(".vbw-gs2-match-links .--youtube-link")
        .attr("href", data.youTubeLink);
      templates.match
        .find(".vbw-gs2-match-links .--youtube-link")
        .attr("title", data.competitionFullName + " youtube link");
      templates.match.find(".vbw-gs2-match-links .--youtube-link").show();
      templates.match.find(".vbw-gs2-match-links .--vbtv-link").hide();
    } else {
      templates.match.find(".vbw-gs2-match-links .--vbtv-link").hide();
      templates.match.find(".vbw-gs2-match-links .--youtube-link").hide();
    }
  } else {
    templates.match.find(".vbw-gs2-match-links .--ticket").hide();
    templates.match.find(".vbw-gs2-match-links .--shop").hide();
    templates.match.find(".vbw-gs2-match-links .--youtube-link").hide();
    templates.match.find(".vbw-gs2-match-links .--vbtv-link").hide();
  }
}

const updateMatchCenterLink = (data, templates) => {
  if (data.matchCenterUrl && isTeamNoValid(data.teamANo) && isTeamNoValid(data.teamBNo)) {
    templates.match.find(".vbw-match-center-link").attr("href", data.matchCenterUrl);
    templates.match.find(".vbw-match-center-link").removeClass("disabled");
    templates.match.find(".vbw-match-center-link").css("visibility", "visible");
    templates.match.find(".vbw-gs2-mc-wrap").attr("href", data.matchCenterUrl);
    templates.match.find(".vbw-gs2-mc-wrap").css("display", "block");
  } else {
    templates.match.find(".vbw-match-center-link").attr("href", "#");
    templates.match.find(".vbw-match-center-link").addClass("disabled");
    templates.match.find(".vbw-match-center-link").css("visibility", "hidden");
    templates.match.find(".vbw-gs2-mc-wrap").attr("href", "#");
    templates.match.find(".vbw-gs2-mc-wrap").css("display", "none");
  }
}

const updateSetsContent = (data, templates) => {
  if (data.matchStatus === 1 || data.matchStatus === 2) {
    templates.match.find(".--home .vbw-gs2-match-sets").html(getSetsContent(data.sets, "home"));
    templates.match.find(".--away .vbw-gs2-match-sets").html(getSetsContent(data.sets, "away"));
  }
}

const updateMatchRoundPool = (data, templates) => {
  const poolName = data.pool?.name ?? "";
  let roundName = data.roundName;
  const phaseName = data.phase?.name;
  const courtName = data.courtText;
  let poolRoundPhase = "";
  if (data.discipline === "volley") {
    if (!!poolName && !!roundName) {
      roundName = " - " + roundName;
    }
  } else if (data.discipline === "beach") {
    if (!!phaseName && !poolName) {
      roundName = phaseName + " - " + roundName;
    } else if (!!poolName && !!roundName) {
      roundName = " - " + roundName;
    }
    if (courtName) {
      roundName = roundName + " - " + courtName;
    }
  }
  poolRoundPhase = poolName + roundName;
  if (data.matchNoInTournament) {
    poolRoundPhase += " #" + data.matchNoInTournament;
  }
  templates.match.find(".vbw-round-pool-phase").text(poolRoundPhase);
}

export const updateMatchRanking = (templates, matchData, rankings, homeContent, awayContent) => {
  const tournamentData = rankings?.filter(r => +r.n_Tournament_NO === matchData.tournamentNo);
  if (tournamentData?.length === 0) return null;

  const matchRankings = tournamentData[0].Matches?.filter(m => +m.n_No === matchData.matchNo);
  if (matchRankings?.length === 0) return null;

  const matchRanking = matchRankings[0];
  const cVal = {
    sc_3_0: +parseFloat(matchRanking["incr_3-0"]).toFixed(2),
    sc_3_1: +parseFloat(matchRanking["incr_3-1"]).toFixed(2),
    sc_3_2: +parseFloat(matchRanking["incr_3-2"]).toFixed(2),
    sc_2_3: +parseFloat(matchRanking["incr_2-3"]).toFixed(2),
    sc_1_3: +parseFloat(matchRanking["incr_1-3"]).toFixed(2),
    sc_0_3: +parseFloat(matchRanking["incr_0-3"]).toFixed(2)
  }

  updateMatchRankRow(templates.rankingsCard, cVal, matchData, homeContent, matchRanking, ".--home");
  updateMatchRankRow(templates.rankingsCard, cVal, matchData, awayContent, matchRanking, ".--away");

  templates.rankingsCard.find(".vbw-gs2-rankings-table").attr("data-status", matchData.matchStatus === 2 ? "completed" : "future")
  templates.rankingsCard.find(".vbw-gs2-rankings-footer a").attr("href", matchData.worldRankingUrl.replace("~", ""));

  return templates.rankingsCard.html();
}

const updateMatchRankRow = (selector, cVal, matchData, teamContent, matchRanking, className) => {
  const mx = className === ".--home" ? 1 : -1;
  const trend = getMatchRankData(matchRanking, matchData, className === ".--home");

  selector.find(`${className} [data-table-trend-wrapper]`).removeClass();
  selector.find(`${className} [data-table-trend-wrapper]`).addClass(`vbw-o-table-trend-wrapper ${trend.iconClass}`);
  selector.find(`${className} .trend-numb`).text(trend.trendChange === 0 ? "" : Math.abs(trend.trendChange));

  selector.find(`${className} .rk-row.--rank`).text(trend.rank);
  selector.find(`${className} .rk-row.--team .vbw-gs2-team-wrap`).html($(teamContent).find(".vbw-gs2-team-wrap").html());
  selector.find(`${className} .rk-row.--score`).text(parseFloat(trend.score).toFixed(2));

  if (className === ".--home") {
    selector.find(`${className} .rk-row.--sc30`).text(cVal.sc_3_0 * mx).removeClass("-pos").removeClass("-neg").addClass(getScoreClass(matchData, cVal.sc_3_0 * mx, 3, 0));
    selector.find(`${className} .rk-row.--sc31`).text(cVal.sc_3_1 * mx).removeClass("-pos").removeClass("-neg").addClass(getScoreClass(matchData, cVal.sc_3_1 * mx, 3, 1));
    selector.find(`${className} .rk-row.--sc32`).text(cVal.sc_3_2 * mx).removeClass("-pos").removeClass("-neg").addClass(getScoreClass(matchData, cVal.sc_3_2 * mx, 3, 2));
    selector.find(`${className} .rk-row.--sc23`).text(cVal.sc_2_3 * mx).removeClass("-pos").removeClass("-neg").addClass(getScoreClass(matchData, cVal.sc_2_3 * mx, 2, 3));
    selector.find(`${className} .rk-row.--sc13`).text(cVal.sc_1_3 * mx).removeClass("-pos").removeClass("-neg").addClass(getScoreClass(matchData, cVal.sc_1_3 * mx, 1, 3));
    selector.find(`${className} .rk-row.--sc03`).text(cVal.sc_0_3 * mx).removeClass("-pos").removeClass("-neg").addClass(getScoreClass(matchData, cVal.sc_0_3 * mx, 0, 3));
  } else {
    selector.find(`${className} .rk-row.--sc03`).text(cVal.sc_3_0 * mx).removeClass("-pos").removeClass("-neg").addClass(getScoreClass(matchData, cVal.sc_3_0 * mx, 3, 0));
    selector.find(`${className} .rk-row.--sc13`).text(cVal.sc_3_1 * mx).removeClass("-pos").removeClass("-neg").addClass(getScoreClass(matchData, cVal.sc_3_1 * mx, 3, 1));
    selector.find(`${className} .rk-row.--sc23`).text(cVal.sc_3_2 * mx).removeClass("-pos").removeClass("-neg").addClass(getScoreClass(matchData, cVal.sc_3_2 * mx, 3, 2));
    selector.find(`${className} .rk-row.--sc32`).text(cVal.sc_2_3 * mx).removeClass("-pos").removeClass("-neg").addClass(getScoreClass(matchData, cVal.sc_2_3 * mx, 2, 3));
    selector.find(`${className} .rk-row.--sc31`).text(cVal.sc_1_3 * mx).removeClass("-pos").removeClass("-neg").addClass(getScoreClass(matchData, cVal.sc_1_3 * mx, 1, 3));
    selector.find(`${className} .rk-row.--sc30`).text(cVal.sc_0_3 * mx).removeClass("-pos").removeClass("-neg").addClass(getScoreClass(matchData, cVal.sc_0_3 * mx, 0, 3));
  }

  return selector;
}

export const isTeamNoValid = (teamNo) => {
  const intMinValue = -2147483648;
  return teamNo !== intMinValue && teamNo !== -1 && teamNo !== 0;
}

export const updateCompetitionCard = (templates, data, genders) => {
  const compName = getCompetitionName(data);
  templates.yearlyCard.find(".vbw-gs2-comp-title").text(compName);
  const endDate = new Date(data.endDate);
  const startDate = new Date(data.startDate);
  templates.yearlyCard.find(".vbw-gs2-comp-dates .start-date").text(startDate.getDate())
  templates.yearlyCard.find(".vbw-gs2-comp-dates .start-month").text(startDate.toLocaleString('default', { month: 'short' }));
  templates.yearlyCard.find(".vbw-gs2-comp-dates .start-year").text(startDate.getFullYear());
  templates.yearlyCard.find(".vbw-gs2-comp-dates .end-date").text(endDate.getDate())
  templates.yearlyCard.find(".vbw-gs2-comp-dates .end-month").text(endDate.toLocaleString('default', { month: 'short' }));
  templates.yearlyCard.find(".vbw-gs2-comp-dates .end-year").text(endDate.getFullYear());
  templates.yearlyCard.find(".vbw-gs2-comp-venue").text(data.destination);
  const tournamentNo = data.menTournaments ? data.menTournaments : data.womenTournaments;

  if (!data.url || data.url === "#nolink") {
    templates.yearlyCard.find(".vbw-comp-page-link").each(function () {
      $(this).addClass("disabled");
      $(this).attr("href", "#nolink");
      $(this).attr("title", "");
    });
  } else {
    templates.yearlyCard.find(".vbw-comp-page-link").each(function () {
      $(this).removeClass("disabled");
      $(this).attr("href", data.url);
      $(this).attr("title", compName);
    });
  }

  templates.yearlyCard
    .find(".vbw-gs2-comp-img-wrap img")
    .attr("data-comp-square-logo", tournamentNo);

  templates.yearlyCard
    .find(".vbw-gs2-comp-img-wrap img")
    .attr("src", "");

  templates.yearlyCard
    .find(".vbw-gs2-comp-img-wrap img")
    .attr("alt", data?.competitionFullName + " logo");

  templates.yearlyCard
    .find("[js-comp-item]")
    .attr("data-discipline", data?.discipline);

  templates.yearlyCard
    .find("[js-comp-item]")
    .attr(`data-gender`, genders.toString());

  templates.yearlyCard
    .find("[js-comp-item]")
    .attr("data-year", data?.season);

  templates.yearlyCard
    .find("[js-comp-item]")
    .attr("data-comptype", convertToSlug(data?.subCompetitionType));

  const months = getCompetitionMonths(startDate, endDate);

  if (months) {
    templates.yearlyCard
      .find("[js-comp-item]")
      .attr(`data-month`, months.toString());
  }

  const youtubeLink = data.youtubeCallToAction?.url;
  const vbtvLink = data.vbtvCallToAction?.url;
  const ticketLink = data.ticketsCallToAction?.url;
  const storeLink = data.storeCallToAction?.url;

  if (ticketLink) {
    templates.yearlyCard
      .find(".vbw-gs2-match-links .--ticket")
      .attr("href", ticketLink);
    templates.yearlyCard
      .find(".vbw-gs2-match-links .--ticket")
      .attr("title", compName + " tickets");
    templates.yearlyCard.find(".vbw-gs2-match-links .--ticket").show();
  } else {
    templates.yearlyCard.find(".vbw-gs2-match-links .--ticket").hide();
  }

  if (storeLink) {
    templates.yearlyCard
      .find(".vbw-gs2-match-links .--shop")
      .attr("href", storeLink);
    templates.yearlyCard
      .find(".vbw-gs2-match-links .--shop")
      .attr("title", compName + " shop link");
    templates.yearlyCard.find(".vbw-gs2-match-links .--shop").show();
  } else {
    templates.yearlyCard.find(".vbw-gs2-match-links .--shop").hide();
  }

  if (vbtvLink) {
    templates.yearlyCard
      .find(".vbw-gs2-match-links .--vbtv-link")
      .attr("href", vbtvLink);
    templates.yearlyCard
      .find(".vbw-gs2-match-links .--vbtv-link")
      .attr("title", compName + " vbtv link");
    templates.yearlyCard.find(".vbw-gs2-match-links .--vbtv-link").show();
    templates.yearlyCard.find(".vbw-gs2-match-links .--youtube-link").hide();
  } else if (youtubeLink) {
    templates.yearlyCard
      .find(".vbw-gs2-match-links .--youtube-link")
      .attr("href", youtubeLink);
    templates.yearlyCard
      .find(".vbw-gs2-match-links .--youtube-link")
      .attr("title", compName + " youtube link");
    templates.yearlyCard.find(".vbw-gs2-match-links .--youtube-link").show();
    templates.yearlyCard.find(".vbw-gs2-match-links .--vbtv-link").hide();
  }
  else {
    templates.yearlyCard.find(".vbw-gs2-match-links .--vbtv-link").hide();
    templates.yearlyCard.find(".vbw-gs2-match-links .--youtube-link").hide();
  }
  return templates.yearlyCard;
};

export const getCompetitionMonths = (startDate, endDate) => {
  const startDateObj = new Date(startDate.getFullYear(), startDate.getMonth());
  let months = [];
  if (startDateObj <= endDate) {
    months.push(startDateObj.getMonth());
    startDateObj.setMonth(startDateObj.getMonth() + 1);
  }
  return months;
}

export const updateLiveMatch = (match, data) => {
  updateMatchCardClass("vbw-gs2-match-item", match, data?.status);

  if (data.status === 1 || data.status === 2) {
    match
      .find(".--home .vbw-gs2-match-sets")
      .html(getSetsContent(data?.sets, "home"));
    match
      .find(".--away .vbw-gs2-match-sets")
      .html(getSetsContent(data?.sets, "away"));
    match
      .find(".vbw-gs2-team-score-wrap.--home .vbw-gs2-score")
      .text(data?.matchPointsA);
    match
      .find(".vbw-gs2-team-score-wrap.--away .vbw-gs2-score")
      .text(data?.matchPointsB);
  }

  if (data.status === 2) {
    const winner = data.matchPointsA > data.matchPointsB ? "--home" : "--away";
    match
      .find(`.vbw-gs2-team-score-wrap.${winner}`)
      .children()
      .removeClass("--winner");
    match
      .find(`.vbw-gs2-team-score-wrap.${winner}`)
      .children()
      .addClass("--winner");
  }
};

export const getTeamContent = (templates, data, teams, type) => {
  const tbdReplacement =
    type === "home" ? data?.teamAReplacementTBD : data?.teamBReplacementTBD;
  const teamNo = type === "home" ? data?.teamANo : data?.teamBNo;
  let teamScore = type === "home" ? data?.teamAScore : data?.teamBScore;
  if (teamScore < 0) {
    teamScore = "";
  }

  const teamData = teams?.filter((x) => x.no === teamNo)[0];

  if (data?.discipline === "volley") {
    return [
      teamData,
      updateVolleyTeam(
        templates.volleyTeam,
        teamData,
        teamScore,
        type,
        data?.winnerTeamNo,
        tbdReplacement,
      ),
    ];
  }
  return [
    teamData,
    updateBeachTeam(
      templates.beachTeam,
      teamData,
      teamScore,
      type,
      data?.winnerTeamNo,
      tbdReplacement,
    ),
  ];
};

export const isTeamBye = (teamData) => {
  return teamData?.no === -1;
};

export const updateVolleyTeam = (
  template,
  teamData,
  teamScore,
  type,
  winner,
  tbdReplacement,
) => {
  const isBye = isTeamBye(teamData);
  template.find("[gs2-match-team-card]").removeClass();
  template
    .find("[gs2-match-team-card]")
    .addClass(`vbw-gs2-team-score-wrap --volley --${type}`);
  template.find("img").attr("src", teamData?.img);
  template.find("img").attr("alt", window.gsConfig.translations.volleyImgText?.replace('{0}', teamData?.country));

  template.find(".vbw-gs2-team-wrap").removeClass("--winner");
  template.find(".vbw-gs2-score-wrap").removeClass("--winner");
  if (teamData?.no === winner) {
    template.find(".vbw-gs2-team-wrap").addClass("--winner");
    template.find(".vbw-gs2-score-wrap").addClass("--winner");
  }

  let teamName = teamData?.translatedName;
  if (isBye && teamName === "TBD") {
    teamName = window.gsConfig?.byeTranslatedText?.toUpperCase();
  } else if (teamName === "TBD" && tbdReplacement) {
    teamName = tbdReplacement;
  }
  template.find(".vbw-gs2-team-name").text(teamName);
  template.find(".vbw-gs2-team-name-abbr").text(teamData?.code);
  template.find(".vbw-gs2-score").text(teamScore);
  template
    .find("[gs2-match-team-card]")
    .attr("data-team-name", teamData?.translatedName);
  return template.html();
};

export const updateBeachTeam = (
  template,
  teamData,
  teamScore,
  type,
  winner,
  tbdReplacement,
) => {
  const isBye = isTeamBye(teamData);
  const playerNames = teamData?.name?.split("/");
  let playerOne = playerNames[0] ? playerNames[0] : "";
  const playerTwo = playerNames[1] ? playerNames[1] : "";
  if (isBye && playerOne === "TBD") {
    playerOne = window.gsConfig?.byeTranslatedText?.toUpperCase();
  } else if (playerOne === "TBD" && tbdReplacement) {
    playerOne = tbdReplacement;
  }

  template.find("[gs2-match-team-card]").removeClass();
  template
    .find("[gs2-match-team-card]")
    .addClass(`vbw-gs2-team-score-wrap --beach --${type}`);

  template.find(".vbw-gs2-team-wrap").removeClass("--winner");
  template.find(".vbw-gs2-score-wrap").removeClass("--winner");
  if (teamData?.no === winner) {
    template.find(".vbw-gs2-team-wrap").addClass("--winner");
    template.find(".vbw-gs2-score-wrap").addClass("--winner");
  }

  template.find("img").attr("src", teamData?.img);
  template.find("img").attr("alt", teamData.altText ? teamData.altText : window.gsConfig.translations.beachVolleyImgText?.replace('{0}', teamData?.country));
  template.find(".player-1").text(playerOne);
  template.find(".player-2").text(playerTwo);
  template.find(".vbw-gs2-score").text(teamScore);
  template.find("[gs2-match-team-card]").attr("data-player1", playerOne);
  template.find("[gs2-match-team-card]").attr("data-player2", playerTwo);
  return template.html();
};

export const getSetsContent = (setsArr, side) => {
  setsArr = setsArr?.sort((a, b) => {
    if (a.no > b.no) return 1;
    if (b.no > a.no) return -1;
    return 0;
  });
  const content = [];

  for (const i in setsArr) {
    if (setsArr[i].pointsTeamA !== 0 && setsArr[i].pointsTeamB !== 0) {
      let setA = "";
      let setB = "";

      if (setsArr[i].pointsTeamA > setsArr[i].pointsTeamB) {
        setA = "--win";
      } else if (setsArr[i].pointsTeamA < setsArr[i].pointsTeamB) {
        setB = "--win";
      }

      content.push(
        `<p class="vbw-set-item ${side == "home" ? setA : setB}">${side == "home" ? setsArr[i].pointsTeamA : setsArr[i].pointsTeamB
        }</p>`,
      );
    }
  }

  return content.join("");
};

export const renderCompetitionLogo = (competitionLogos) => {
  $("[data-comp-square-logo]").each(function () {
    $(this).hide();
    $(this).siblings().show();
  });

  if (!competitionLogos) return;

  competitionLogos?.forEach((item) => {
    if (item?.squaredLogo?.thumbnailUrl) {
      if (item?.menTournamentNumber) {
        $(`[data-comp-square-logo="${item.menTournamentNumber}"]`).each(
          function () {
            $(this).attr(
              "src",
              item?.squaredLogo?.thumbnailUrl + "." + item?.squaredLogo?.format,
            );
            $(this).show();
            $(this).siblings().hide();
          },
        );
      }

      if (item?.womenTournamentNumber) {
        $(`[data-comp-square-logo="${item.womenTournamentNumber}"]`).each(
          function () {
            $(this).attr(
              "src",
              item?.squaredLogo?.thumbnailUrl + "." + item?.squaredLogo?.format,
            );
            $(this).show();
            $(this).siblings().hide();
          },
        );
      }
    }
  });
};

export const updateMatchCardClass = (elementClass, match, matchStatus) => {
  const hiddenClass = match.hasClass("hidden") ? "hidden" : "";
  let statusClass = "";

  switch (matchStatus) {
    case 1:
      statusClass = "vbw-mu-live";
      break;
    case 2:
      statusClass = "vbw-mu-finished";
      break;
    case 0:
    default:
      statusClass = "vbw-mu-scheduled";
  }

  match.removeClass();
  match.addClass(`${elementClass} ${statusClass} ${hiddenClass}`);
};

export const showLoading = (selector, content, loadingSelector = ".vbw-gs2-matches") => {
  selector.find(loadingSelector).html(content.html());
};

export const hideLoading = (selector, loadingSelector = ".vbw-gs2-matches") => {
  selector.find(loadingSelector).empty();
};

export const getCompListString = (listArr) => {
  let comps = "";
  if (listArr?.length === 1) {
    return listArr[0].no;
  }
  listArr?.forEach((x) => {
    comps += x.no + ";";
  });
  return comps.substring(0, comps.length - 1);
};

export const getYearlyCompListString = (listArr) => {
  let comps = "";
  if (listArr?.length === 1) {
    return listArr[0]?.menTournaments ?? listArr[0]?.womenTournaments;
  }
  listArr?.forEach((x) => {
    let code;
    if (x.menTournaments) {
      code = x.menTournaments;
    } else if (x.womenTournaments) {
      code = x.womenTournaments;
    } else {
      code = undefined;
    }

    if (code) comps += code + ";";
  });
  return comps.substring(0, comps.length - 1);
};

export const containsCompetition = (obj, list) => {
  return list.some(function (elem) {
    return elem.competitionFullName === obj.competitionFullName;
  });
};

export const containsDiscipline = (obj, list) => {
  return list.some(function (elem) {
    return elem.discipline === obj.discipline;
  });
};

export const getWeeklyNavsDateRangesObj = (baseDate) => {
  if (!baseDate) return;
  const currentEndDate = new Date(
    baseDate.getFullYear(),
    baseDate.getMonth(),
    baseDate.getDate(),
    23,
    59,
    59,
    0,
  );
  const prevEndDate = new Date(
    baseDate.getFullYear(),
    baseDate.getMonth(),
    baseDate.getDate(),
    23,
    59,
    59,
    0,
  );
  const nextEndDate = new Date(
    baseDate.getFullYear(),
    baseDate.getMonth(),
    baseDate.getDate(),
    23,
    59,
    59,
    0,
  );
  const prevStartDate = new Date(
    baseDate.getFullYear(),
    baseDate.getMonth(),
    baseDate.getDate(),
    0,
    0,
    0,
    0,
  );
  const nextStartDate = new Date(
    baseDate.getFullYear(),
    baseDate.getMonth(),
    baseDate.getDate(),
    0,
    0,
    0,
    0,
  );
  baseDate.setHours(0, 0, 0, 0);

  currentEndDate.setDate(baseDate.getDate() + 6);
  prevEndDate.setDate(baseDate.getDate() - 1);
  prevStartDate.setDate(baseDate.getDate() - 7);
  nextStartDate.setDate(baseDate.getDate() + 7);
  nextEndDate.setDate(baseDate.getDate() + 13);
  return {
    currentRangeDates: {
      startDate: baseDate,
      endDate: currentEndDate,
    },
    prevRangeDates: {
      startDate: prevStartDate,
      endDate: prevEndDate,
    },
    nextRangeDates: {
      startDate: nextStartDate,
      endDate: nextEndDate,
    },
  };
};

export const getFormattedUtcOffset = (utcOffset) => {
  let offsetHours = parseInt(Math.abs(utcOffset / 60));
  let offsetMins = Math.abs(utcOffset % 60);
  let formattedOffset = null;
  if (offsetHours < 10) offsetHours = "0" + offsetHours;
  if (offsetMins < 10) offsetMins = "0" + offsetMins;
  if (utcOffset <= 0) {
    formattedOffset = offsetHours + ":" + offsetMins;
  } else if (utcOffset > 0) {
    formattedOffset = "-" + offsetHours + ":" + offsetMins;
  }
  return formattedOffset;
};

export const getGlobalScheduleApiDateRange = (weeklyNavDates) => {
  if (!weeklyNavDates) return;
  const groupStart = new Date(
    weeklyNavDates.currentRangeDates.startDate.valueOf(),
  );
  const groupEnd = new Date(
    weeklyNavDates.currentRangeDates.startDate.valueOf(),
  );
  // set to Monday of this current week
  groupStart.setDate(groupStart.getDate() - ((groupStart.getDay() + 6) % 7));
  // set to previous Monday
  groupStart.setDate(groupStart.getDate() - 7);
  // set to next Sunday
  groupEnd.setDate(groupStart.getDate() + 20);
  return [getDateString(groupStart), getDateString(groupEnd)];
};

export const getWeeklyNavDateString = (fromDate, toDate) => {
  if (!toDate || !fromDate) return;

  const monthStrings = window.gsConfig?.translations?.months;
  if (toDate.getMonth() === fromDate.getMonth()) {
    return `${fromDate.getDate()} - ${toDate.getDate()} ${monthStrings[fromDate.getMonth()]
      }`;
  } else {
    return `${fromDate.getDate()} ${monthStrings[fromDate.getMonth()]
      } - ${toDate.getDate()} ${monthStrings[toDate.getMonth()]}`;
  }
};

export const validateParamFromDates = (urlParamDates) => {
  const fromDate = new Date(urlParamDates.fromDate);
  return fromDate instanceof Date && !isNaN(fromDate);
};

export const getUrlParam = () => {
  const hash = window.location.hash.substring(1);
  if (hash) {
    return hash.split("&").reduce(function (res, item) {
      const parts = item.split("=");
      res[parts[0]] = parts[1];
      return res;
    }, {});
  }
  return null;
};

export const updateFilterSearchParam = ($elem, value, _this) => {
  _this.searchParamsObj[
    $elem
      .parents(".vbw-filters--container")
      .find(".filters-dropdown")
      .attr("id")
  ] = value;
};

const getMatchRankData = (trendData, matchData, isHome) => {
  let iconClass = "trend-arrow-equal";
  let trendChange;
  let rank = isHome ? trendData.n_PreHomeWR : trendData.n_PreAwayWR;
  let score = isHome ? trendData.f_PreHomeWRS : trendData.f_PreAwayWRS;

  if (matchData.matchStatus === 2) {
    if (isHome) {
      trendChange = Number(trendData.n_PreHomeWR) - Number(trendData[`WR_Home_${matchData.teamAScore}-${matchData.teamBScore}`]);
      if (trendChange > 0) {
        iconClass = "trend-arrow-up";
      } else if (trendChange < 0) {
        iconClass = "trend-arrow-down";
      }
      rank = trendData[`WR_Home_${matchData.teamAScore}-${matchData.teamBScore}`];
      score = Number(trendData.f_PreHomeWRS) + Number(trendData[`incr_${matchData.teamAScore}-${matchData.teamBScore}`]);
    } else {
      trendChange = Number(trendData.n_PreAwayWR) - Number(trendData[`WR_Away_${matchData.teamAScore}-${matchData.teamBScore}`]);
      if (trendChange > 0) {
        iconClass = "trend-arrow-up";
      } else if (trendChange < 0) {
        iconClass = "trend-arrow-down";
      }
      rank = trendData[`WR_Away_${matchData.teamAScore}-${matchData.teamBScore}`];
      score = Number(trendData.f_PreAwayWRS) + (Number(trendData[`incr_${matchData.teamAScore}-${matchData.teamBScore}`]) * -1);
    }

    return { iconClass: iconClass, trendChange: trendChange, rank: rank, score: score }
  } else {
    return { iconClass: iconClass, trendChange: 0, rank: rank, score: score };
  }
}

const getScoreClass = (matchData, points, teamA, teamB) => {

  if (matchData.matchStatus === 2) { // finished/post Match
    if (matchData.teamAScore === teamA && matchData.teamBScore === teamB) {
      return points > 0 ? "-pos" : "-neg";
    } else {
      return "";
    }
  } else {
    return points > 0 ? "-pos" : "-neg";
  }
}
